export default __webpack_public_path__ + "static/media/brw-loading.2b97af58.jpeg";